module.exports = __webpack_public_path__ + "img/tarjeta1.e7fa2fde.svg";